<template>
	<tr class="md-table-row" v-if="member">
		<td class="md-table-cell"><div class="md-table-cell-container"><span class="display-link" @click="goToProfile()">{{displayName(member)}}</span></div></td>
		<td v-if="!settings" class="md-table-cell"><div class="md-table-cell-container"><span class="display-link" @click="goToProfile()">{{member.emails[0]}}</span></div></td>
		<template v-if="settings">
			<td class="md-table-cell"><div class="md-table-cell-container text-center"><md-checkbox @change="updateAdminSettings(settings._id,'approvals')" v-model="settings.approvals"></md-checkbox></div></td>
			<td class="md-table-cell"><div class="md-table-cell-container text-center"><md-checkbox @change="updateAdminSettings(settings._id,'escalate')" v-model="settings.escalate"></md-checkbox></div></td>
			<td class="md-table-cell"><div class="md-table-cell-container text-center"><md-checkbox @change="updateAdminSettings(settings._id,'reports')" v-model="settings.reports"></md-checkbox></div></td>
			<td class="md-table-cell"><div class="md-table-cell-container text-center"><md-checkbox @change="updateAdminSettings(settings._id,'members')" v-model="settings.members"></md-checkbox></div></td>
			<td class="md-table-cell"><div class="md-table-cell-container text-center"><md-checkbox @change="updateAdminSettings(settings._id,'requests')" v-model="settings.requests"></md-checkbox></div></td>
			<td class="md-table-cell"><div class="md-table-cell-container text-center"><md-checkbox @change="updateAdminSettings(settings._id,'responses')" v-model="settings.responses"></md-checkbox></div></td>
			<td class="md-table-cell"><div class="md-table-cell-container text-center"><md-checkbox @change="updateAdminSettings(settings._id,'donor')" v-model="settings.donor"></md-checkbox></div></td>
			<td class="md-table-cell"><div class="md-table-cell-container text-center"><md-checkbox @change="updateAdminSettings(settings._id,'feedback')" v-model="settings.feedback"></md-checkbox></div></td>
			<td class="md-table-cell"><div class="md-table-cell-container text-center"><md-checkbox @change="updateAdminSettings(settings._id,'referee')" v-model="settings.referee"></md-checkbox></div></td>
			<td class="md-table-cell"><div class="md-table-cell-container text-center"><md-checkbox @change="updateAdminSettings(settings._id,'unsubscribe')" v-model="settings.unsubscribe"></md-checkbox></div></td>
			<td class="md-table-cell"><div class="md-table-cell-container text-center"><md-checkbox @change="updateAdminSettings(settings._id,'profileupdate')" v-model="settings.profileupdate"></md-checkbox></div></td>
			<td class="md-table-cell"><div class="md-table-cell-container text-center"><md-checkbox @change="updateAdminSettings(settings._id,'nofollowup')" v-model="settings.nofollowup"></md-checkbox></div></td>
		</template>
		<td  class="md-table-cell" v-if="$lodash.has(member.requestReceived, 'lastRequestReceived') && !settings"><div class="md-table-cell-container">{{ member.requestReceived.lastRequestReceived | momentDate }}</div></td>
		<td class="md-table-cell" v-else-if="!settings"><div class="md-table-cell-container">---</div></td>
		<td class="md-table-cell" v-if="$lodash.has(member.response, 'lastResponse') && !settings"><div class="md-table-cell-container">{{ member.response.lastResponse | momentDate }}</div></td>
		<td class="md-table-cell" v-else-if="!settings"><div class="md-table-cell-container">---</div></td>
		<td class="md-table-cell" v-if="$lodash.has(member, 'lastFeedback') && !settings"><div class="md-table-cell-container">{{ member.lastFeedback | momentDate }}</div></td>
		<td class="md-table-cell" v-else-if="!settings"><div class="md-table-cell-container">---</div></td>
		<td class="md-table-cell">
			<div class="md-table-cell-container" v-if="dataType === 'advisor' && member.community == $route.params.community_id || dataType === 'administrator'">
				<md-dialog-confirm
		          :md-active.sync="active"
		          md-title="Delete Confirmation"
		          :md-content="setContent"
		          @md-confirm="removeAdmin" />
				<span class="md-remove" @click="active = true">Remove</span>
			</div>
		</td>
	</tr>
</template>
<script>
import API from "../services/API";
export default {
  props: ["member", "dataType", "settings"],
  data() {
  	return {
		  active: false,
		  api: new API(),
		  Load: this.isLoad
  	}
  },
  computed: {
  	setContent: function() {
  		return `<strong>Are you sure you want to delete the ${this.dataType}?</strong>`
  	}
  },
  methods: {
    goToProfile: function() {
      let route = this.$router.resolve({path: `/members/${this.member._id}`});
      window.open(route.href, '_blank');
    },
    displayName(member) {
		  return this.$lodash.has(member, 'first') ? member.first + ' ' + member.last : member.displayName;
  	},
  	removeAdmin: function() {
		this.$emit('remove', this.member._id);
	},
  	updateAdminSettings: async function(settingId, type) {
		if (settingId !== "" && type !== "") {
			await this.api.post(`communities/${this.$route.params.community_id}/update-admin-settings`, {
				settings: this.settings
			});
		}
	}
  }
};
</script>



// WEBPACK FOOTER //
// src/components/AdminList.vue